<template>
    <div class="loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
    <div class="message" v-if="text">
        <p>{{ text }}</p>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        text: {type: String, required: false}
    }
});
</script>

<style scoped>

.loader, .message{
    margin: 25px 25%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.loader > div{
    width: 20px;
    height: 20px;
    background: var(--color-principal);
    border-radius: 50%;
    margin: 3px;
    animation-name: loader;
    animation-duration: 600ms;
    animation-iteration-count: infinite;
    animation-direction: alternate;
}

.loader > div:nth-child(2){
    animation-delay: 0.1s;
}

.loader > div:nth-child(3){
    animation-delay: 0.2s;
}
.loader > div:nth-child(4){
    animation-delay: 0.3s;
}
.loader > div:nth-child(5){
    animation-delay: 0.4s;
}
.loader > div:nth-child(6){
    animation-delay: 0.5s;
}

@keyframes loader {
    to {
        opacity: 0.1;
        transform: translate(0, -20px);
        background : #E7ECF4;
    }
}
.message {
    color: var(--color-principal);
    font-weight: var(--font-weight-bold);
}
</style>
